exports["DE"] = require("./DE.js");
exports["IL"] = require("./IL.js");